/**
 * Created by sivanh on 09/01/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ApiKeyIpRangeItemModel = require("manager-models/data-sources/api-keys/ApiKeyIpRangeItemModel");
    var Validator = require("utils/ValidationUtilities");
    var BaseCollection = require("collections/BaseCollection");

    var ApiKeyIpRangesCollection = {};
    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        ApiKeyIpRangesCollection = BaseCollection.extend({
            model : ApiKeyIpRangeItemModel,
            /**
             * Allows multiple includes
             * No duplicates
             * The list size must not exceed 1000 (property)
             * @param attrs
             * @returns {*}
             */
            validate : function () {
                var errors = {};

                this.setDuplicates();

                _.each(this.models, function(ipRangeModel) {
                    var modelErrors = ipRangeModel.validate();
                    if (modelErrors) {
                        errors = modelErrors;
                    }
                });

                // Trigger validated events.
                // Need to defer this so the model is actually updated before
                // the event is triggered.
                _.defer(_.bind(function() {
                    this.trigger('validated:' + (_.isEmpty(errors) ? 'valid' : 'invalid'), this, errors);
                }, this));

                return errors;
            },

            setDuplicates: function() {
                // clean up
                _.each(this.models, function(model) {
                    model.errors.withinListDuplicated = false;
                });

                // find duplicates
                var duplicatedItems = Validator.findDuplicationsInCollection(this,
                    function(model1, model2){
                        return model1.getFromIp() === model2.getFromIp()&&
                            model1.getToIp()  === model2.getToIp();
                    });

                // mark them
                _.each(duplicatedItems, function(duplicatedModel) {
                    duplicatedModel.errors.withinListDuplicated = true;
                });
            }

        });

    });
    return ApiKeyIpRangesCollection;
});
